/**
 * Search + Status filter, shared by CalendarsPage and AlertsPage — was two
 * near-identical copies. Calendars also filters by Template; Alerts doesn't
 * (only one template is meaningfully in use today, per product decision) —
 * gated behind the optional `templateFilterOptions` prop instead of a
 * second hard-coded copy.
 */
import React from "react";
import Input from "../../theme/untitled/Input/Input";
import Icon from "../../theme/untitled/icons/Icon";
import FilterPopover from "./FilterPopover";
import useWindowSize from "../../../../hooks/useWindowSize";
import styles from "./Toolbar.module.scss";

const STATUS_FILTER_OPTIONS = [
  { value: "published", label: "Published" },
  { value: "unpublished", label: "Unpublished" },
];

const Toolbar = ({
  search,
  onSearchChange,
  statusValues,
  onStatusChange,
  itemLabelPlural,
  templateFilterOptions,
  templateValues,
  onTemplateChange,
}) => {
  // Input's own `.field` height (36/40px) isn't reachable from outside via
  // className (it's applied to an inner div, not the root className merges
  // onto) — bumping to the "md" size prop gets closer to the 44px mobile
  // touch-target rule than fighting that from here.
  const { width } = useWindowSize();
  const isMobile = width && width <= 767;

  return (
    <div className={styles.root}>
      <div className={styles.search}>
        <Input
          size={isMobile ? "md" : "sm"}
          placeholder={`Search ${itemLabelPlural}`}
          iconLeading={<Icon name="SearchLg" />}
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          aria-label={`Search ${itemLabelPlural}`}
        />
      </div>
      <div className={styles.filters}>
        <FilterPopover
          label="Status"
          options={STATUS_FILTER_OPTIONS}
          selectedValues={statusValues}
          onChange={onStatusChange}
        />
        {templateFilterOptions && (
          <FilterPopover
            label="Template"
            options={templateFilterOptions}
            selectedValues={templateValues}
            onChange={onTemplateChange}
          />
        )}
      </div>
    </div>
  );
};

export default Toolbar;
